<template>
<div>
  <div v-if="!isLoaded">
    <progress-ring radius="60" :progress="progress" stroke="4"></progress-ring>
  </div>

  <div v-if="isLoaded">
  <div class="row">
    <div class="full">
      <div class="envn" style="margin-left:10px">
        <div class="row">
          <div class="fifty">
            <h2>{{ instance.SERVICE.serviceName }} <span :class="'launch-stage ' + instance.SERVICE.launchStage"><sup>{{ $t("launchStage."+instance.SERVICE.launchStage) }}</sup></span></h2>
            <div id="deprecation-notice" v-if="instance.SERVICE.deprecation">
              <vue-markdown :source="instance.SERVICE.deprecation"></vue-markdown>
            </div>
            <p>{{ instance.SERVICE.summary }}</p>
          </div>
          <div class="fifty">
            <router-link :to="{ name: 'service-edit', params: { serviceid: instance.SERVICE.id }}" class="see-all" style="margin-right: 0px; margin-left: auto;">{{ $t("service.edit-service") }}</router-link>
          </div>
        </div>
        <div class="row" :id="instance.SERVICE.id">
            <div class="thirty">
              <h3>{{ $t("service.environments") }}</h3>
              <ul class="big-tag">
                <li v-for="(status, env) in instance.SERVICE.environment" v-if="status"><router-link :to="{ name: 'service-home', query: { environment: env }}">{{ $t("environments." + env) }}</router-link></li>
              </ul>
              <h3>{{ $t("service.failure") }}</h3>
              <p class="hero"><span v-if="instance.SERVICE.safeToFail">{{ $t("service.is-safe-to-fail") }}</span><span style="color:#ed4a65" v-else>{{ $t("service.is-not-safe-to-fail") }}</span></p>
              <h3>{{ $t("service.error-budget-heading") }}</h3>
              <p class="hero"><strong>{{ instance.SERVICE.errorBudget }} <span class="sublight">{{ $t("service.per-month") }}</span></strong></p>
              <h3>{{ $t("service.business-value")}}</h3>
              <svg width="325" height="325" xmlns="http://www.w3.org/2000/svg">
               <g>
                <title>background</title>
                <rect x="0" y="0" width="325" height="325" id="canvas_background" fill="none"/>
               </g>

               <g>
                <title>Background</title>
                <rect id="svg_1" height="75" width="75" y="0" x="25" stroke-width="1" stroke="#ccc" fill="#fae3e8"/>
                <rect id="svg_2" height="75" width="75" y="0" x="100" stroke-width="1" stroke="#ccc" fill="#f3a3a1"/>
                <rect id="svg_3" height="75" width="75" y="0" x="175" stroke-width="1" stroke="#ccc" fill="#ed462f"/>
                <rect id="svg_14" height="75" width="75" y="0" x="250" stroke-width="1" stroke="#ccc" fill="#ed462f"/>

                <rect id="svg_4" height="75" width="75" y="75" x="25" stroke-width="1" stroke="#ccc" fill="#fff"/>
                <rect id="svg_5" height="75" width="75" y="75" x="100" stroke-width="1" stroke="#ccc" fill="#fae3e8"/>
                <rect id="svg_6" height="75" width="75" y="75" x="175" stroke-width="1" stroke="#ccc" fill="#f3a3a1"/>
                <rect id="svg_15" height="75" width="75" y="75" x="250" stroke-width="1" stroke="#ccc" fill="#ed462f"/>

                <rect id="svg_7" height="75" width="75" y="150" x="25" stroke-width="1" stroke="#ccc" fill="#fff"/>
                <rect id="svg_8" height="75" width="75" y="150" x="100" stroke-width="1" stroke="#ccc" fill="#fff"/>
                <rect id="svg_9" height="75" width="75" y="150" x="175" stroke-width="1" stroke="#ccc" fill="#fae3e8"/>
                <rect id="svg_16" height="75" width="75" y="150" x="250" stroke-width="1" stroke="#ccc" fill="#f3a3a1"/>

                <rect id="svg_11" height="75" width="75" y="225" x="25" stroke-width="1" stroke="#ccc" fill="#fff"/>
                <rect id="svg_12" height="75" width="75" y="225" x="100" stroke-width="1" stroke="#ccc" fill="#fff"/>
                <rect id="svg_13" height="75" width="75" y="225" x="175" stroke-width="1" stroke="#ccc" fill="#fff"/>
                <rect id="svg_17" height="75" width="75" y="225" x="250" stroke-width="1" stroke="#ccc" fill="#fae3e8"/>
               </g>
               <g>
                <title>Point</title>
                <text xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="24" id="svg_10" :y="textYpostion" :x="textXpostion" stroke-width="0" stroke="#000" fill="#000000">◆</text>
               </g>
                <g>
                <title>How often legend</title>
                <text transform="rotate(-90 0,0)" xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="12" id="svg_18" y="15" x="-300" stroke-width="0" stroke="#000" fill="#000000">{{ $t("howoften.abbr-little") }}</text>
                <text transform="rotate(-90 0,0)" xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="12" id="svg_18" y="15" x="-225" stroke-width="0" stroke="#000" fill="#000000">{{ $t("howoften.abbr-some") }}</text>
                <text transform="rotate(-90 0,0)" xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="12" id="svg_18" y="15" x="-150" stroke-width="0" stroke="#000" fill="#000000">{{ $t("howoften.abbr-most") }}</text>
                <text transform="rotate(-90 0,0)" xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="12" id="svg_18" y="15" x="-75" stroke-width="0" stroke="#000" fill="#000000">{{ $t("howoften.abbr-all") }}</text>
               </g>
                 <g>
                <title>How many people legend</title>
                <text xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="12" id="svg_18" y="320" x="25" stroke-width="0" stroke="#000" fill="#000000">{{ $t("howmany.abbr-few") }}</text>
                <text xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="12" id="svg_18" y="320" x="100" stroke-width="0" stroke="#000" fill="#000000">{{ $t("howmany.abbr-some") }}</text>
                <text xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="12" id="svg_18" y="320" x="175" stroke-width="0" stroke="#000" fill="#000000">{{ $t("howmany.abbr-most") }}</text>
                <text xml:space="preserve" text-anchor="start" font-family="Helvetica, Arial, sans-serif" font-size="12" id="svg_18" y="320" x="250" stroke-width="0" stroke="#000" fill="#000000">{{ $t("howmany.abbr-all") }}</text>
               </g>
              </svg>

            </div>
            <div class="thirty">
              <h3>{{ $t("service.known-impacts") }}</h3>
              <ul class="big-tag">
                <li v-for="service in instance.SERVICE.knownImpacts"><router-link :to="{ name: 'service-view', params: { serviceid: service.id }}">{{ service.serviceName}}</router-link></li>
              </ul>

              <h3>{{ $t("service.data-compliance") }}</h3>
              <ul class="big-tag">
                <li v-for="(status, reg) in instance.SERVICE.dataCompliance" v-if="status"><router-link :to="{ name: 'service-home', query: { compliance: reg }}">{{ reg }}</router-link></li>
              </ul>

              <h3>{{ $t("service.deployment") }}</h3>
              <dl>
                <dt>{{ $t("service.deployment-frequency") }}</dt>
                <dd>{{ instance.SERVICE.deploymentFrequency }}</dd>
                <dt>{{ $t("service.leadtime") }}</dt>
                <dd>{{ instance.SERVICE.leadTime }}</dd>
                <dt>{{ $t("service.meantime") }}</dt>
                <dd>{{ instance.SERVICE.meanTimeRestore }}</dd>
                <dt>{{ $t("service.change-rate") }}</dt>
                <dd>{{ instance.SERVICE.changeFailureRate }}</dd>
              </dl>

              <h3>{{ $t("service.impacted-by-adrs") }}</h3>
              <ul>
                <li v-for="spec in instance.SPEC"><router-link :to="{ name: 'spec-view', params: { specid: spec.id }}">{{ spec.title}}</router-link></li>
              </ul>
            </div>
            <div class="thirty">
              <table>
                <thead>
                  <tr>
                    <th colspan="3" style="background-color:#061b26; color: #fff; padding-left: 5px; "> <abbr :title='$t("service.slo-title")'>{{ $t("service.slos-abbr") }}</abbr> </th>
                    <th colspan="3" style="background-color:#ed4a65; color: #fff; padding-left: 5px;">{{ $t("service.qc-dt")}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td><strong><abbr :title='$t("service.nfp-title")'>{{ $t("service.nfp-abbr") }}</abbr></strong></td>
                    <td><strong>{{ $t("service.predicate") }}</strong></td>
                    <td><strong>{{ $t("service.metric") }}</strong></td>
                    <td><strong><abbr :title='$t("service.nfp-title")'>{{ $t("service.nfp-abbr") }}</abbr></strong></td>
                    <td><strong>{{ $t("service.predicate") }}</strong></td>
                    <td><strong>{{ $t("service.metric") }}</strong></td>
                  </tr>
                  <tr v-for="slo in instance.SERVICE.slos">
                    <td>{{ slo.slo.NFP }}</td>
                    <td class="predicate"> {{ slo.slo.Predicate }}</td>
                    <td>{{ slo.slo.Metric }}</td>
                    <td>{{ slo.qc.NFP }}</td>
                    <td class="predicate"> {{ slo.qc.Predicate }}</td>
                    <td>{{ slo.qc.Metric }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
    </div>
    </div>
  </div>
  </div>
</div>
</template>
<script>
import VueMarkdown from 'vue-markdown'
import { RepositoryFactory } from '@/services/repositoryfactory'
const ServiceRepository = RepositoryFactory.get('services');
import ProgressRing from '@/components/progress-ring.vue'

export default {
  name: 'Service',
  props: ['serviceid'],
  components: {
    ProgressRing,
    VueMarkdown
  },
  data () {
    return {
      isLoaded: false,
      instance: null,
      progress: 0,
      html: {
        title: null
      }
    }
  },
  metaInfo () {
    return {
      title: this.html.title
    }
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {

      const interval = setInterval(() => {
        this.progress += 1;
        if (this.progress === 100)
          clearInterval(interval);
      }, 100);

      if(this.serviceid) {
        this.instance = await ServiceRepository.getService(this.serviceid);
        this.html.title = this.instance.SERVICE.serviceName;
        this.isLoaded = true;
      } else {
        this.$router.push('/');
      }
    },
    setMatrixPostion: function(element) {
      // I see you rolling your eyes!
      switch (element) {
        case 'textX':
          return (75 * this.instance.SERVICE.redRoutes.howMany) - 20;
          break;
        case 'textY':
          return (75 * this.instance.SERVICE.redRoutes.howOften) - 30;
          break;
        default:
          return 0;
      }
    },
  },
  computed: {
    textXpostion() {
      return this.setMatrixPostion("textX");
    },
    textYpostion() {
      return this.setMatrixPostion("textY");
    }
  }
};
</script>
<style>
ul.big-tag {
  list-style: none;
  margin: 0.2rem 0 0.5rem;
  padding: 0;
}

.big-tag li {
  font-size: 1.2rem;
  border-bottom: 2px solid #c7d3eb;
  display: inline-block;
  margin-left: 10px;
  padding:0 10px;
  font-weight: bold;
  color:#2c3e50;
}

.big-tag a {
  text-decoration: none;
  color: #061b26;
}

h2 {
  color:#2c3e50;
  font-size: 1.5rem;
}

h3 {
  color:#2c3e50;
  font-size: 0.75rem;
}

dl {
  margin: 0.2rem 0 0.3rem;
}

dt {
  color:#2c3e50;
  font-size: 0.75rem;
}

dd {
  font-size: 1.2rem;
  font-weight: bold;
  color: #7e87ab;
}

.explainer dt {
  font-size: 0.9rem;
}

.explainer dd {
  font-size: 0.8rem;
}

.sublight {
  color:#c7d3eb;
  font-size: 0.8rem;
}

.hero {
  font-size: 1.3rem;
  font-weight: bold;
  color: #7e87ab;
  margin: 0.2rem 0;
}

td.predicate
{
    text-align: center;
    vertical-align: middle;
}
</style>
